The identifier for the `Event`.
